import { config } from "../config";

export function getWsGraphqlUrl() {
  return `${config.ssl ? "wss:" : "ws:"}//${config.host}${
    config.port !== 80 && config.port !== 443 ? `:${config.port}` : ""
  }${config.serverUrl}`;
}
